import { render, staticRenderFns } from "./TableCaption.vue?vue&type=template&id=18c9530e"
import script from "./TableCaption.vue?vue&type=script&lang=js"
export * from "./TableCaption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports